import { render, staticRenderFns } from "./HookNamespace.vue?vue&type=template&id=05a8b54c&scoped=true&"
import script from "./HookNamespace.vue?vue&type=script&lang=js&"
export * from "./HookNamespace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a8b54c",
  null
  
)

export default component.exports